import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './file-entry.reducer';

export const FileEntryDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const fileEntryEntity = useAppSelector(state => state.fileEntry.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="fileEntryDetailsHeading">
          <Translate contentKey="xtdtApp.fileEntry.detail.title">FileEntry</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{fileEntryEntity.id}</dd>
          <dt>
            <span id="ten">
              <Translate contentKey="xtdtApp.fileEntry.ten">Ten</Translate>
            </span>
          </dt>
          <dd>{fileEntryEntity.ten}</dd>
          <dt>
            <span id="tenMoRong">
              <Translate contentKey="xtdtApp.fileEntry.tenMoRong">Ten Mo Rong</Translate>
            </span>
          </dt>
          <dd>{fileEntryEntity.tenMoRong}</dd>
          <dt>
            <span id="duongDan">
              <Translate contentKey="xtdtApp.fileEntry.duongDan">Duong Dan</Translate>
            </span>
          </dt>
          <dd>{fileEntryEntity.duongDan}</dd>
          <dt>
            <span id="tenHienThi">
              <Translate contentKey="xtdtApp.fileEntry.tenHienThi">Ten Hien Thi</Translate>
            </span>
          </dt>
          <dd>{fileEntryEntity.tenHienThi}</dd>
        </dl>
        <Button tag={Link} to="/file-entry" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/file-entry/${fileEntryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default FileEntryDetail;
